import styled from 'styled-components/macro'

const FieldList = styled.div`
  margin: 2em 0 1.5em;
`

export default FieldList
